<template>
    <svg
        id="icon_fullscreen"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="30"
        height="30"
        viewBox="0 0 30 30"
    >
        <defs>
            <linearGradient
                id="linear-gradient"
                x1="0.5"
                x2="0.5"
                y2="1"
                gradientUnits="objectBoundingBox"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#e3bdff" />
            </linearGradient>
        </defs>
        <path
            id="icon_fullscreen-2"
            data-name="icon_fullscreen"
            d="M2239-477h-22a4,4,0,0,1-4-4v-22a4,4,0,0,1,4-4h22a4,4,0,0,1,4,4v22A4,4,0,0,1,2239-477Zm-23-13v10h9v-3h-4.364l4.364-4.364-2.121-2.121L2219-485.607V-490Zm21-8.393V-494h3v-10h-9v3h4.364L2231-496.635l2.121,2.121L2237-498.39Z"
            transform="translate(-2213 507)"
            fill="url(#linear-gradient)"
        />
    </svg>
</template>
